import './calculationExecutionLog.scss';
import {CalculationsLogServiceName, CUSTOMER_DETAILS_SERVICE_NAME} from "../../../utils/names/serviceNames";
import {
    CustomerOpportunityDialog
} from "../../../opportunities/component/customerOpportunityDialog/CustomerOpportunityDialog";
import {IComponentController, IHttpPromise, ILocationService, IOnChangesObject, IPromise, IScope} from "angular";
import {CustomerDetailsService} from "../../../customer_service/service/CustomerDetailService";
import {OpportunityLog} from "../../../opportunities/model/Opportunity";
import {CalculationsLogService} from "../../../logging_lqb_funded/services/CalculationsLogService";
import {Cursor} from "../../../utils/models/Page";

export interface CalculationExecutionLogScope extends IScope {
    getExecutionDuration: (l: OpportunityLog) => string;
    navigateTo: (customerId: number) => void;
    logs: OpportunityLog[];
    logPromise: IHttpPromise<any>;
    openOpportunityModal: ($event, opportuntity) => void;
    fetchLog: (nextCursor?: number, beforeCursor?: number) => IPromise<OpportunityLog[]>;
    pagingConfig: Cursor<OpportunityLog>;
}

export class CalculationExecutionLog implements IComponentController {

    static instance = {
        controller: [
            '$scope',
            '$location',
            CUSTOMER_DETAILS_SERVICE_NAME,
            '$mdDialog',
            CalculationsLogServiceName,
            CalculationExecutionLog
        ],
        template: require('./calculationExecutionLog.html'),
        bindings: {
            pagingConfig: '<',
            logs: '<',
            fetchLogs: '<'
        }
    };

    private $mdDialog: angular.material.IDialogService;
    private $scope: CalculationExecutionLogScope;
    private pagingConfig: Cursor<OpportunityLog>;
    private logs: OpportunityLog[];
    private fetchLogs: (nextCursor?: number, beforeCursor?: number) => IPromise<OpportunityLog[]>;
    private loggingService: CalculationsLogService;
    private $location: ILocationService;


    constructor($scope: CalculationExecutionLogScope,
                $location: ILocationService,
                CustomerDetailService: CustomerDetailsService,
                $mdDialog: angular.material.IDialogService,
                loggingService: CalculationsLogService) {
        $scope.openOpportunityModal = this.openOpportunityModal;
        $scope.navigateTo = this.navigateTo;
        $scope.getExecutionDuration = this.getExecutionDuration;
        this.$mdDialog = $mdDialog;
        this.loggingService = loggingService;
        this.$scope = $scope;
        this.$location = $location;
    }

    openOpportunityModal = ($event, opportuntityLog: OpportunityLog) => {
        this.loggingService.getCalculationsDetails(opportuntityLog.id)
            .then(resp => {
                let opportunity = resp.data;
                this.$mdDialog.show(CustomerOpportunityDialog.instance($event, opportunity, true, false));
            })
    };

    $onInit = () => {
        let $scope = this.$scope;
        $scope.logs = this.logs;
        $scope.fetchLog = this.fetchLogs;
        $scope.pagingConfig = this.pagingConfig;
    };

    navigateTo = (customerId: number) => {
        this.$location.url(`/contact_profile/${customerId}`);
    };

    $onChanges(onChangesObj: IOnChangesObject): void {
        this.listenToPropCahnges(onChangesObj, 'logs', (logs: OpportunityLog[]) => this.$scope.logs = logs);
        this.listenToPropCahnges(onChangesObj, 'pagingConfig', (pagingConfig: Cursor<OpportunityLog>) => this.$scope.pagingConfig = pagingConfig);
    }

    getExecutionDuration = (l: OpportunityLog): string => {
        let finished = new Date(l.finishedExecution);
        let started = new Date(l.startedExecution);
        return (finished.getTime() - started.getTime()) / 1000.0 + 's'
    };

    private listenToPropCahnges<T>(onChangesObj: IOnChangesObject, propName: string, callback: (change: T) => void) {
        var popChange = onChangesObj[propName];
        if (popChange && !popChange.isFirstChange()) {
            callback(popChange.currentValue);
        }
    }
}